import { formatRoundedNumber } from '@/lib/formatUtils';
import { FormFieldV2 } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';

interface BottomBarProps {
  tongTien: number;
  tongThanhToan: number;
  ty_gia: number;
}

export function BottomBar({ tongTien, tongThanhToan, ty_gia }: BottomBarProps) {
  return (
    <div className='w-full border-t bg-white px-4 py-2 pb-6'>
      <div className='flex'>
        <div className='flex flex-col'>
          <div className='flex items-center gap-4'>
            <Label className='mt-2 w-28 font-semibold'>Tổng tiền</Label>
            <FormFieldV2 name='t_tien_nt' className='font-semibold' value={formatRoundedNumber(tongTien)} />
          </div>
          <div className='flex items-center gap-4'>
            <Label className='mt-2 w-28 font-semibold'>Tổng thanh toán</Label>
            <FormFieldV2 name='t_tt_nt' className='font-semibold' value={formatRoundedNumber(tongThanhToan)} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default BottomBar;
